import { render, staticRenderFns } from "./thirds_config_view.vue?vue&type=template&id=98c6d72c&scoped=true"
import script from "./thirds_config_view.vue?vue&type=script&lang=js"
export * from "./thirds_config_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c6d72c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c6d72c')) {
      api.createRecord('98c6d72c', component.options)
    } else {
      api.reload('98c6d72c', component.options)
    }
    module.hot.accept("./thirds_config_view.vue?vue&type=template&id=98c6d72c&scoped=true", function () {
      api.rerender('98c6d72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/config/thirds_config_view.vue"
export default component.exports